import React from 'react';
import "../assets/css/Production.css";

const Production = () => <React.Fragment />

export default Production;


// WEBPACK FOOTER //
// ./src/environments/Production.js